import { HttpStatusCode } from '../constants';

export const AWAIT_RATE_LIMIT_RETRY = 1000;
export const AWAIT_FIRST_RETRY = 3000;
export const AWAIT_SECOND_RETRY = 10000;

export const RETRY_ERROR_CODES = [
  HttpStatusCode.InternalServerError,
  HttpStatusCode.BadGateway,
  HttpStatusCode.ServiceUnavailable,
];

export const ROOT_BASE_URL = '/';
